/**
 * KUR-AL logosu — kural-web'deki resmi SVG'lerin (logo.svg / logo-alt.svg) bilesen hali.
 *
 * Iki varyant:
 * - `mark`: yalniz uc yesil cubuk (kompakt yerler: topbar).
 * - `full`: cubuklar + KURAL yazisi (marka ani: giris ekranlari).
 *
 * Renkler CSS degiskenlerinden gelir ki tema/ada yeniden-baglamalari calissin
 * (bkz. AuthScreens.module.css > .card deseni):
 * - cubuklar: --logo-bar-deep / --logo-bar-mid / --logo-bar-bright
 *   (acik tema varsayilanlari logo-alt.svg paleti; koyu zeminde logo.svg paleti
 *   tokens.css'te --logo-ink-bar-* olarak hazir durur)
 * - KURL harfleri: currentColor (metin rengini izler)
 * - A harfi: --logo-accent (acik temada yesil, koyu zeminde metin rengi —
 *   resmi beyaz-metinli logoda A da beyazdir)
 *
 * Dekoratif oge: aria-hidden sabittir, erisilebilir ad cevredeki h1/metinden gelir.
 */

export interface BrandLogoProps {
  variant?: 'mark' | 'full';
  className?: string | undefined;
}

const BAR_DEEP =
  'M44.07,85.82h-17.13l17.13-21.4v-16.84h-15.85c-8.72,0-15.85,7.13-15.85,15.85v49.64h15.85c8.72,0,15.85-7.13,15.85-15.85v-11.41Z';
const BAR_MID =
  'M56.43,64.42l17.13,21.4h-17.13v27.26h15.85c8.72,0,15.85-7.13,15.85-15.85v-41.3h-17.13l17.13-21.4v-10.74h-15.85c-8.72,0-15.85,7.13-15.85,15.85v24.78Z';
const BAR_BRIGHT =
  'M100.49,113.07h15.85c8.72,0,15.85-7.13,15.85-15.85V0h-15.85c-8.72,0-15.85,7.13-15.85,15.85v18.68l17.13,21.4h-17.13v57.15Z';
const LETTERS_KURL =
  'M118.18,163.28v-31.4h4.67v26.74h13.53v4.67h-18.19ZM52.56,163.28v-31.4h11.55c1.7,0,3.24.42,4.6,1.26,1.36.84,2.44,1.96,3.25,3.37.8,1.41,1.2,2.99,1.2,4.73,0,1.47-.27,2.8-.81,4.02-.55,1.21-1.31,2.24-2.29,3.1-.98.85-2.1,1.47-3.36,1.84l7.58,13.1h-5.41l-7.36-12.67v-4.67h2.11c.9,0,1.72-.22,2.46-.67.74-.45,1.32-1.05,1.76-1.79.43-.75.65-1.59.65-2.53s-.22-1.79-.65-2.55c-.43-.76-1.02-1.35-1.76-1.79-.74-.44-1.56-.66-2.46-.66h-6.39v27.34h-4.67ZM36.17,163.87c-2.51,0-4.7-.61-6.56-1.84-1.86-1.23-3.3-2.88-4.33-4.95-1.02-2.07-1.54-4.37-1.54-6.89v-18.3h4.67v18.3c0,1.64.31,3.15.91,4.52.61,1.37,1.49,2.46,2.65,3.28,1.16.82,2.56,1.23,4.2,1.23s3.11-.41,4.26-1.23c1.15-.82,2.03-1.91,2.62-3.28.59-1.37.88-2.87.88-4.52v-18.3h4.67v18.3c0,1.9-.29,3.67-.87,5.32-.58,1.65-1.42,3.11-2.51,4.37-1.09,1.26-2.4,2.24-3.93,2.94-1.53.7-3.23,1.05-5.11,1.05ZM21.98,163.28h-6.06l-9.35-12.94-1.91,2.31v10.63H0v-31.4h4.67v13.53l11.31-13.53h6.1l-12.43,14.83,12.34,16.58ZM76.5,146.65h12.9l-.34.67-3,5.89h-9.56v-6.56Z';
const LETTER_A =
  '101.92 131.59 109.28 147.32 116.64 163.05 111.14 163.05 109.28 159.07 101.92 143.34 94.56 159.07 92.7 163.05 87.2 163.05 94.56 147.32 101.92 131.59';

export const BrandLogo = ({ variant = 'full', className }: BrandLogoProps) => (
  <svg
    className={className}
    viewBox={variant === 'mark' ? '12.37 0 119.82 113.07' : '0 0 136.37 163.87'}
    role="presentation"
    aria-hidden="true"
    focusable="false"
  >
    <path d={BAR_DEEP} fill="var(--logo-bar-deep, #206656)" fillRule="evenodd" />
    <path d={BAR_MID} fill="var(--logo-bar-mid, #188c71)" fillRule="evenodd" />
    <path d={BAR_BRIGHT} fill="var(--logo-bar-bright, #27ba98)" fillRule="evenodd" />
    {variant === 'full' ? (
      <>
        <path d={LETTERS_KURL} fill="currentColor" fillRule="evenodd" />
        <polygon points={LETTER_A} fill="var(--logo-accent, #188c71)" />
      </>
    ) : null}
  </svg>
);
